import { useEffect, useState } from "react";
import { fileBlob } from "@/lib/api";

export function useFileObjectURL(id) {
  const [state, setState] = useState({ url: null, error: "" });
  useEffect(() => {
    if (!id) { setState({ url: null, error: "" }); return; }
    const controller = new AbortController();
    let url;
    setState({ url: null, error: "" });
    fileBlob(id, controller.signal).then((blob) => {
      if (!controller.signal.aborted) { url = URL.createObjectURL(blob); setState({ url, error: "" }); }
    }).catch((failure) => { if (!controller.signal.aborted) setState({ url: null, error: failure.message }); });
    return () => { controller.abort(); if (url) URL.revokeObjectURL(url); };
  }, [id]);
  return state;
}

export function PrivateImage({ id, alt, ...props }) {
  const { url, error } = useFileObjectURL(id);
  if (error) return <span role="status" data-testid={`private-image-error-${id}`} className="text-xs text-jarvis-amber">Preview unavailable</span>;
  return url ? <img src={url} alt={alt} {...props} /> : <span className="text-xs text-slate-500">Loading…</span>;
}
